import { mergeSpecialisationsFromFilters } from "./marketplaceFilterApply";

function joinCsv(value) {
  if (Array.isArray(value) && value.length) return value.join(",");
  return undefined;
}

/** Convert filter panel state to marketplace API query params. */
export function filtersToMarketplaceApiParams(filters = {}, { serviceTab, radiusKm } = {}) {
  const careType = serviceTab || filters.careType || "attendant";
  const active = { ...filters, careType };
  const specialisations = mergeSpecialisationsFromFilters(active);

  const params = {
    radiusKm,
    specialisations,
  };

  if (active.minRating > 0) params.minRating = active.minRating;
  if (careType) params.careType = careType;
  if (active.gender && active.gender !== "any") params.gender = active.gender;
  if (active.ageGroup) params.ageGroup = active.ageGroup;
  if (active.minExperience > 0) params.minExperience = active.minExperience;
  if (active.verifiedOnly) params.verifiedOnly = "true";
  if (active.religion && active.religion !== "any") params.religion = active.religion;
  if (active.foodPreference && active.foodPreference !== "any") params.foodPreference = active.foodPreference;
  if (active.sleepArrangement) params.sleepArrangement = active.sleepArrangement;
  if (active.availableNow) params.availableNow = "true";
  if (active.shiftType) params.shiftType = active.shiftType;
  const resolvedSalaryServiceType =
    active.salaryServiceType && active.salaryServiceType !== "both"
      ? active.salaryServiceType
      : undefined;
  if (resolvedSalaryServiceType) params.salaryServiceType = resolvedSalaryServiceType;
  if ((active.salaryHourlyMin ?? 0) > 0) params.salaryHourlyMin = active.salaryHourlyMin;
  if ((active.salaryMonthlyMin ?? 0) > 0) params.salaryMonthlyMin = active.salaryMonthlyMin;
  if (active.salaryHourlyMax < 5000) params.salaryHourlyMax = active.salaryHourlyMax;
  if (active.salaryMonthlyMax < 100000) params.salaryMonthlyMax = active.salaryMonthlyMax;

  const patientConditions = joinCsv(active.patientConditions);
  if (patientConditions) params.patientConditions = patientConditions;
  const languages = joinCsv(active.languages);
  if (languages) params.languages = languages;
  const skills = joinCsv(active.skills);
  if (skills) params.skills = skills;

  if (careType === "nurses") {
    const nurseClinical = joinCsv(active.nurseClinical);
    if (nurseClinical) params.nurseClinical = nurseClinical;
    const nurseQualifications = joinCsv(active.nurseQualifications);
    if (nurseQualifications) params.nurseQualifications = nurseQualifications;
    const nurseSkills = joinCsv(active.nurseSkills);
    if (nurseSkills) params.nurseSkills = nurseSkills;
  }

  if (careType === "physio") {
    const physioRequirements = joinCsv(active.physioRequirements);
    if (physioRequirements) params.physioRequirements = physioRequirements;
    if (active.physioFrequency) params.physioFrequency = active.physioFrequency;
    if (active.physioDuration) params.physioDuration = active.physioDuration;
    if (active.consultationType) params.consultationType = active.consultationType;
  }

  if (active.packageKey) params.packageKey = active.packageKey;
  if (active.serviceId) params.serviceId = active.serviceId;

  return params;
}
